import { RouteRecordRaw } from 'vue-router';
import { ApprovalDocumentPage } from '@/pages/approval';

export const routeName = 'Documento';

export const route: RouteRecordRaw = {
  path: 'documentos/:id',
  name: routeName,
  component: ApprovalDocumentPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Documento',
  },
};
